import { Component } from 'react';
import { Tabs, Tab, Container, Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { history } from '../../store';
import PageTitle from '../common/page-title/index';
import TeamSubmissionFormPage from './sell-it-uploader/submission-form-page';
import PostcodePlanFormPage from './postcode-plan/postcode-plan-form-page';
import SubmissionsDashboard from './dashboard/submissions-dashboard';
import './index.css';
import { getOutlets } from '../../actions/pip-epos-data-missing-weeks';
import AutoEposPriceItPlusFormPage from './auto-epos-price-it-plus/auto-epos-price-it-plus-form-page';

export const pages = {
  submit_epos_data: 'SUBMIT EPOS/INVOICE',
  my_dashboard: 'MY DASHBOARD'
};

class Submissions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tab: 'submit_ngp_data'
    };
  }

  UNSAFE_componentWillMount() {
    const { location: { hash }, dispatch } = this.props;
    let tab = hash;

    if (!tab) {
      tab = 'submit_ngp_data';
    } else {
      tab = tab.substr(1);
    }

    this.setState({ tab });
    this.handleTabSelect(tab);

    dispatch(getOutlets());
  }

  handleTabSelect = (tab) => {
    history.replace(`/submissions#${tab}`);
    this.setState({ tab });
  };

  render() {
    const { outlets } = this.props;
    const { tab } = this.state;
    const hasPipEposDataMissingWeeksOutlets = outlets && outlets.length !== 0;

    return (
      <Container className="sell-it-submissions user-inner-container">
        <Row>
          <Col lg={12} className="sell-it-submissions-title">
            <PageTitle>Submissions</PageTitle>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <div className={`sell-it-submissions-${hasPipEposDataMissingWeeksOutlets ? 'additional-tabs' : 'tabs'}`}>
              <Tabs
                activeKey={tab}
                onSelect={this.handleTabSelect}
                id="submissionsTab"
                mountOnEnter
              >
                <Tab eventKey="submit_ngp_data" title="BLU&nbsp;BAR&nbsp;SELL&nbsp;IT UPLOADER">
                  <TeamSubmissionFormPage isNgp />
                </Tab>
                <Tab eventKey="submit_postcode_plan_data" title="SUBMIT&nbsp;PRICE&nbsp;IT&nbsp;+ EPOS/INVOICE">
                  <PostcodePlanFormPage />
                </Tab>
                <Tab eventKey="submit_epos_data" title="SUBMIT&nbsp;SELL&nbsp;IT EPOS/INVOICE">
                  <TeamSubmissionFormPage />
                </Tab>
                <Tab eventKey="my_dashboard" title="MY&nbsp;DASHBOARD">
                  <SubmissionsDashboard
                    handleTabSelect={this.handleTabSelect}
                  />
                </Tab>
                {hasPipEposDataMissingWeeksOutlets && (
                  <Tab eventKey="auto_epos_price_it_plus_uploader" title="AUTO PRICE IT+ UPLOADER">
                    <AutoEposPriceItPlusFormPage />
                  </Tab>
                )}
              </Tabs>
            </div>
          </Col>
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  outlets: state.pipEposDataMissingWeeks.outlets,
});

export default connect(mapStateToProps)(Submissions);
